module.exports = __webpack_public_path__ + "img/quotatio_form.38b8f95e.png";